/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-options.js
// module id = D:\a\1\s\node_modules\webpack\buildin\amd-options.js
// module chunks = site__hca site__evo plugin--simple-modal colour-list